/* src/app/shared/components/dialogs/toast-message/toast-message.component.scss */
.toast-message {
  color: var(--white-color);
  word-wrap: break-word;
}
.toast-icon {
  font-size: 16px;
}
.success-toast {
  color: #21C073;
}
.error-toast {
  color: #FF3A42;
}
.warning-toast {
  color: #F5C451;
}
.info-toast {
  color: #58A6FF;
}
::ng-deep .mat-mdc-snack-bar-container {
  border-radius: 4px;
}
::ng-deep .mat-mdc-snack-bar-container .mat-mdc-snackbar-surface {
  max-width: 672px;
  width: auto;
  min-width: 0px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.7);
}
::ng-deep .mat-mdc-snackbar-surface {
  padding-right: 0px;
}
::ng-deep .mdc-snackbar__label {
  padding: 15px 10px;
}
.toast-hdr {
  margin-left: 4px;
  margin-right: 1px;
}
/*# sourceMappingURL=toast-message.component-AK2354W6.css.map */
